import dayjs, { Dayjs } from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

// The report endpoints (temperature/operation/power/iot-status/wifi-event)
// read `dateTime` as Bangkok wall-clock, whatever X-Time-Zone says. A user in
// Taiwan (+8) asking for their 15:00 hour therefore got the Bangkok 15:00
// window — their 16:00 — and the chart matched nothing (the buckets are built
// in the browser's zone, see getTimeArray). Convert the anchor for the HOURS
// unit only: that window is a specific instant range, so the instant must
// line up. Calendar units keep the user's date untouched — shifting the anchor
// across midnight would select the wrong day/week/month entirely. The days
// unit is completed in apis/reportWindow (it fetches every Bangkok day the
// local day touches and trims); weeks/months keep their one-hour edge until
// the backend honours X-Time-Zone (asked for in the handoff, C9-T4).
const REPORT_ANCHOR_ZONE = "Asia/Bangkok";
export const reportQueryStr = (localDateTime: string, unit: string): string =>
  unit === "hours"
    ? dayjs(localDateTime).tz(REPORT_ANCHOR_ZONE).format("YYYY-MM-DD HH:mm:ss")
    : localDateTime;

// The "YYYY-MM-DD HH:00:00" local anchor every report page builds by hand.
export const localAnchorStr = (date: any, period: number | string): string =>
  `${dayjs(date).format("YYYY-MM-DD")} ${
    period.toString().length < 2 ? `0${period}:00:00` : `${period}:00:00`
  }`;

// The activity-log endpoint reads startDate/endDate as UTC, but everything the
// user picks is local wall-clock. Formatting a local time straight into the
// query shifts the whole window by the timezone offset (+7h here), so a
// one-day range silently returns 07:00 that day through 06:59 the next.
// Convert here instead of at each call site — this has already been the cause
// of one bug per page that forgot it.
export const utcQueryStr = (d: Dayjs | Date): string =>
  new Date(dayjs(d).valueOf()).toISOString().slice(0, 19).replace("T", " ");

export const dateConvert = (e: any) => {
  if (e === "" || e === null) {
    return "-";
  } else {
    return dayjs(e).format("DD/MM/YYYY HH:mm");
  }
};
export const dateConvertDiff = (e: any) => {
  if (e === "" || e === null) {
    return "-";
  } else {
    const date1 = dayjs();
    const diff = date1.diff(e, "minute");
    if (diff <= 1) {
      return "Now";
    } else {
      return dateConvert(e);
    }
  }
};
export const buildTimeMap = (data: any[]): Map<string, any> => {
  const map = new Map<string, any>();
  data.forEach((item) => {
    if (!map.has(item.time)) {
      map.set(item.time, item);
    }
  });
  return map;
};
export const getTimeArray = (date: any, unit = "", interval = 1) => {
  let array = [];
  let s = "";
  let e = "";
  if (unit === "hours") {
    s = dayjs(date).startOf("hour").format();
    e = dayjs(date).endOf("hour").format();
  } else if (unit === "days") {
    s = dayjs(date).startOf("day").format();
    e = dayjs(date).endOf("day").format();
  } else if (unit === "weeks") {
    s = dayjs(date).day(0).startOf("day").format();
    e = dayjs(date).day(6).endOf("day").format();
  } else if (unit === "months") {
    s = dayjs(date).startOf("month").format();
    e = dayjs(date).endOf("month").format();
  }
  for (var m = dayjs(s); m.isBefore(e); m = m.add(interval, "minute")) {
    array.push(m.format("YYYY-MM-DD HH:mm:ss"));
  }
  return array;
};
